<div tabindex="0"
     (blur)="onContainerBlur($event)"
     (mousedown)="onMouseDown($event)"
     (keydown)="onKeyDown($event)" #container>

    <div class="d-flex align-items-center">
        <ng-select data-test="locationDropdown" width="{{selectWidth}}"
                   bindLabel="label"
                   bindValue="id"
                   [loading]="isLoading | async"
                   [loadingText]="'common.loading' | translate"
                   [appendTo]="appendTo"
                   dropdownPosition="auto"
                   [placeholder]="'locations.select.location' | translate"
                   [(ngModel)]="locationSelected"
                   [items]="items"
                   [disabled]="disabled"
                   [virtualScroll]="true"
                   (ngModelChange)="onValueChanged($event)"
                   (open)="search(select.searchTerm)"
                   (scrollToEnd)="fetchMore(select.searchTerm)"
                   (search)="onSearch(select.searchTerm)"
                   (clear)="search(select.searchTerm)"
                   (mousedown)="onMouseDown($event)"
                   [clearable]="clearable" style="flex: 1;" #select>
        </ng-select>
        <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
    </div>
    <div [class.divider]="showDivider" [class.mt-2]="showDivider">
        <div class="row mt-1" *ngIf="showFilterOptions && !storageLocationsOnly">
            <div class="col-xs-12 col-md-12">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="option-group"
                           id='allLocations + {{storageLocationsOnly}}' [value]="false"
                           [(ngModel)]="isBreedingAndCountryLocationsOnly" [disabled]="disabled">
                    <label class="form-check-label" for='allLocations + {{storageLocationsOnly}}'
                           jhiTranslate="germplasm.import.basicDetails.all.locations"></label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="option-group"
                           id='breedingAndCountryLocations + {{storageLocationsOnly}}' [value]="true"
                           [(ngModel)]="isBreedingAndCountryLocationsOnly" [disabled]="disabled">
                    <label class="form-check-label" for='breedingAndCountryLocations + {{storageLocationsOnly}}'
                           jhiTranslate="germplasm.import.basicDetails.breeding.and.country.locations"></label>
                </div>
            </div>
        </div>
        <div class="row mt-1" *ngIf="showFavoritesCheckbox && showFilterOptions">
            <div class="col-xs-12 col-md-12">
                <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input"
                           id='useFavoriteBreedingLocations + {{storageLocationsOnly}}'
                           [(ngModel)]="useFavoriteLocations" [disabled]="disabled">
                    <label class="form-check-label" for='useFavoriteBreedingLocations + {{storageLocationsOnly}}'
                           jhiTranslate="germplasm.import.basicDetails.locations.use.favorite">
                    </label>
                </div>
            </div>
        </div>
        <div class="row mt-1" *ngIf="showCountryField">
            <div class="col-xs-12 col-md-12">
                <div class="form-check form-check-inline">
                    <label class="col-sm-5 m-2 control-label fw-bold"
                           jhiTranslate="crop-settings-manager.location.country">Country</label>
                    <span name="country" class="col-sm-7">{{ countryName }}</span>
                </div>
            </div>
        </div>
    </div>
</div>

